

import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Sidebar from './sidebar';
import { SiPayloadcms } from "react-icons/si";

const WheelEdit = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const wheelKey = searchParams.get("key");
    const [wheelData, setWheelData] = useState(null);
    const [editedData, setEditedData] = useState({});
    const [loading, setLoading] = useState(true);
    const [pies, setPies] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const styles = {
        container: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            minHeight: '100vh',
            fontFamily: 'Arial, sans-serif'
        },
        content: {
            flex: 1,
            padding: isMobile ? '10px' : '20px',
            backgroundColor: '#f4f4f4',
            overflowY: 'auto'
        },
        form: {
            backgroundColor: 'white',
            padding: isMobile ? '15px' : '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            width: isMobile ? '100%' : 'auto',
            maxWidth: isMobile ? '100%' : '600px',
            margin: isMobile ? '0' : '0 auto'
        },
        formGroup: {
            marginBottom: '15px'
        },
        label: {
            display: 'block',
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#333'
        },
        input: {
            width: '100%',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            boxSizing: 'border-box'
        },
        buttonGroup: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '10px',
            marginTop: '20px'
        },
        saveButton: {
            flex: 1,
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            borderRadius: '4px',
            cursor: 'pointer'
        },
        cancelButton: {
            flex: 1,
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            borderRadius: '4px',
            cursor: 'pointer'
        },
        pieSection: {
            marginTop: '20px'
        },
        pieInput: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'stretch' : 'center',
            marginBottom: '10px',
            gap: '10px'
        },
        addPieButton: {
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            borderRadius: '4px',
            cursor: 'pointer',
            width: isMobile ? '100%' : 'auto'
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    
    useEffect(() => {
        const adminVerified = localStorage.getItem('adminVerified');
        if (adminVerified !== 'true') {
            navigate('/');
        }
        fetchWheel();
    }, [navigate, wheelKey]);

    const fetchWheel = async () => {
        setLoading(true);
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL, {
                apikey: process.env.REACT_APP_API_KEY,
                module: "admin",
                method: "adminSingleWheel",
                wheel_id: wheelKey
            });

            const jsonData = JSON.parse(response.data.body);

            if (jsonData.status === "success") {
                setWheelData(jsonData.data);
                setEditedData(jsonData.data);
                setPies(jsonData.data.pies || []);
            } else {
                console.error("Failed to fetch wheel data:", jsonData.message);
            }
        } catch (error) {
            console.error("Error fetching wheel data:", error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePieChange = (index, value) => {
        const newPies = [...pies];
        newPies[index] = value;
        setPies(newPies);
    };

    const addPie = () => {
        setPies([...pies, '']);
    };

    const removePie = (index) => {
        const newPies = pies.filter((_, i) => i !== index);
        setPies(newPies);
    };

    const handleSave = async () => {
        setLoading(true);
        const payload = {
            apikey: process.env.REACT_APP_API_KEY,
                module: "admin",
                method: "updateWheel",
                wheel_id: wheelKey,
                wheel_name:editedData.wheel_name,
                status:editedData.status,
                prize:editedData.prize,
                pies: pies
          };       
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL,payload);
            const jsonData = JSON.parse(response.data.body);
            if (jsonData.status === "success") {
                console.log("Wheel updated successfully!");
                navigate('/');
                // fetchWheel();
            } else {
                console.log(`Update failed: ${jsonData.message}`);
            }
        } catch (error) {
            console.error("Error updating wheel:", error);
            alert("An error occurred while updating the wheel");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <Sidebar />
            <div style={styles.content}>
                <div style={styles.form}>
                    <h2>Edit Wheel</h2>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Wheel Name</label>
                        <input
                            type="text"
                            name="wheel_name"
                            value={editedData.wheel_name || ''}
                            onChange={handleInputChange}
                            style={styles.input}
                        />
                    </div>
                    {/* <div style={styles.formGroup}>
                        <label style={styles.label}>Spin Date</label>
                        <input
                            type="datetime-local"
                            name="spinning_time"
                            value={editedData.spinning_time 
                                ? new Date(editedData.spinning_time).toISOString().slice(0,16) 
                                : ''
                            }
                            onChange={handleInputChange}
                            style={styles.input}
                        />
                    </div> */}
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Status</label>
                        <select
                            name="status"
                            value={editedData.status || ''}
                            onChange={handleInputChange}
                            style={styles.input}
                        >
                            <option value="completed">Completed</option>
                            <option value="paymentpending">Payment Pending</option>
                            <option value="ended">Ended</option>
                        </select>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Prize</label>
                        <input
                            type="text"
                            name="prize"
                            value={editedData.prize || ''}
                            onChange={handleInputChange}
                            style={styles.input}
                        />
                    </div>
                    <div style={styles.pieSection}>
                        <label style={styles.label}>Wheel Pies</label>
                        {pies.map((pie, index) => (
                            <div key={index} style={styles.pieInput}>
                                <input
                                    type="text"
                                    value={pie}
                                    onChange={(e) => handlePieChange(index, e.target.value)}
                                    style={styles.input}
                                />
                                <button 
                                    onClick={() => removePie(index)}
                                    style={{...styles.cancelButton, padding: '8px 12px'}}
                                >
                                    Remove
                                </button>
                            </div>
                        ))}
                        <button 
                            onClick={addPie}
                            style={styles.addPieButton}
                        >
                            Add Pie
                        </button>
                    </div>
                    <div style={styles.buttonGroup}>
                        <button 
                            onClick={handleSave}
                            style={styles.saveButton}
                        >
                            Save Changes
                        </button>
                        <button 
                            onClick={() => navigate(-1)}
                            style={styles.cancelButton}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WheelEdit;